import { render, staticRenderFns } from "./RedeemManagement.vue?vue&type=template&id=b0abb7ba&"
import script from "./RedeemManagement.vue?vue&type=script&lang=js&"
export * from "./RedeemManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports